import { render, staticRenderFns } from "./offer-item.vue?vue&type=template&id=71301f78&scoped=true&"
import script from "./offer-item.vue?vue&type=script&lang=js&"
export * from "./offer-item.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "71301f78",
  null
  ,true
)

export default component.exports